import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { PartyUidSchema } from './general';

export type IcoResult = Static<typeof IcoSchema>;
export const IcoSchema = Type.Object(
  {
    result: Type.Literal('SUCCESS'),
  },
  { additionalProperties: false, $id: 'IcoSchema' }
);

export type CmeResult = Static<typeof CmeSchema>;
export const CmeSchema = Type.Object(
  {
    id: Type.String(),
    responseBody: Type.String(),
    result: Type.Literal('SUCCESS'),
  },
  { additionalProperties: false, $id: 'CmeSchema' }
);

export const WinnerStatusSchema = Type.Union(
  [
    // WINNER_CREATED: Immediately set when winner entity is created in the database
    Type.Literal('WINNER_CREATED'),
    // NOTIFICATION_SENT: Set after successfully calling CME API to send winner email
    Type.Literal('NOTIFICATION_SENT'),
    // PRIZE_CLAIMED: Set when customer claims their prize, this have to be the
    // last status (if used), as it is used to prevent from claiming prize again
    Type.Literal('PRIZE_CLAIMED'),
    // WINNER_INVALIDATED: Set when winner is invalidated
    Type.Literal('WINNER_INVALIDATED'),
  ],
  {
    $id: 'WinnerStatusSchema',
  }
);

export const WinnerEventTypesSchema = Type.Union(
  [
    // WINNER_CREATED: Immediately added when winner entity is created in the database
    Type.Literal('WINNER_CREATED'),
    // WINNER_INVALIDATED: Added when winner is invalidated
    Type.Literal('WINNER_INVALIDATED'),
    // PRIZE_CLAIMED: Added when customer claims their prize
    Type.Literal('PRIZE_CLAIMED'),
    // EMAIL_EVENT_SENT: Email has been sent but not necessarily delivered succesfully
    Type.Literal('EMAIL_EVENT_SENT'),
    // EMAIL_EVENT_DELIVERY: Email has reached target email server
    Type.Literal('EMAIL_EVENT_DELIVERY'),
    // EMAIL_EVENT_INITIAL_OPEN: The email has been opened
    Type.Literal('EMAIL_EVENT_INITIAL_OPEN'),
    // EMAIL_EVENT_OPEN: The email has been opened and scrolled to the bottom
    Type.Literal('EMAIL_EVENT_OPEN'),
    // EMAIL_EVENT_CLICK: Link in email has been clicked
    Type.Literal('EMAIL_EVENT_CLICK'),
    // EMAIL_EVENT_BOUNCE: A-record is missing for domain
    Type.Literal('EMAIL_EVENT_BOUNCE'),
    // EMAIL_EVENT_COMPLAINT: Spam complaint
    Type.Literal('EMAIL_EVENT_COMPLAINT'),
  ],
  {
    $id: 'WinnerEventTypesSchema',
  }
);

export type WinnerEvents = Static<typeof WinnerEventsSchema>;
export const WinnerEventsSchema = Type.Record(
  WinnerEventTypesSchema,
  Type.Optional(Type.Object({ date: Type.String({ format: 'date-time' }) }))
);

export type Winner = Static<typeof WinnerSchema>;
export const WinnerSchema = Type.Object(
  {
    createdAt: Type.String({ format: 'date-time' }),
    partyUid: PartyUidSchema,
    storeId: Type.Optional(Type.String()),
    updatedAt: Type.String({ format: 'date-time' }),
    status: WinnerStatusSchema,
    ico: Type.Optional(IcoSchema),
    cme: Type.Optional(CmeSchema),
    events: WinnerEventsSchema,
  },
  { additionalProperties: false, $id: 'WinnerSchema' }
);
